import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useAlert } from '@rahtab/ui/dist/components/Alert';
import { useEffect, useState } from 'react';
function useCheckWorkflow({ wfInstanceCode, stateCode }: CheckWorkflowProps) {
  const [retries, setRetries] = useState(0);
  const [result, setResult] = useState<{ loading: boolean; data?: { finished: boolean } }>({ loading: false });
  const alert = useAlert();
  const [checkWorkflow, { data, loading, called }] = useFetchCallType<CheckWorkflowInfo>('CheckWorkflowStateFinish', {
    skip: true,
    params: `WFInstanceCode=${wfInstanceCode}&StateCode=${stateCode}`,
  });

  useEffect(() => {
    if (loading) {
      setResult((v) => ({ ...v, loading: true }));
      return;
    }
    if (!data) return;
    console.log('wfCheckResult', data);
    if (data.Finished === false) {
      if (retries < 6) {
        console.log('wf not finished');
        setTimeout(() => {
          setRetries((v) => v + 1);
          checkWorkflow();
        }, 450);
      } else {
        setResult({ loading: false, data: { finished: false } });
      }
    } else {
      console.log('wf finished');
      setResult({ loading: false, data: { finished: true } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return { checkWorkflow, ...result, called };
}

export default useCheckWorkflow;

interface CheckWorkflowProps {
  wfInstanceCode: string;
  stateCode: string;
}

interface CheckWorkflowInfo {
  Finished: boolean;
  Failed: boolean;
  Error: string;
}
